// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AiChatController from "./ai_chat_controller"
application.register("ai-chat", AiChatController);

import TestController from "./test_controller"
application.register("test", TestController);

import ModelUpdaterController from "./model_updater_controller"
application.register("model-updater", ModelUpdaterController);

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import AutoScrollController from "./auto_scroll_controller"
application.register("auto-scroll", AutoScrollController)

import CollapseController from "./collapse_controller"
application.register("collapse", CollapseController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import JoinCodeController from "./join_code_controller"
application.register("join-code", JoinCodeController)

import JoinFormController from "./join_form_controller"
application.register("join-form", JoinFormController)

import JoinCodeOnlyController from "./join_code_only_controller"
application.register("join-code-only", JoinCodeOnlyController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import SearchPanelController from "./search_panel_controller"
application.register("search-panel", SearchPanelController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)
